var exports = {
  "Ki": "FeedVideo.module__video___eUdDcT",
  "W_": "FeedVideo.module__poster___eUdDcT",
  "lW": "FeedVideo.module__posterImage___eUdDcT",
  "ZH": "FeedVideo.module__play___eUdDcT",
  "uZ": "FeedVideo.module__playIcon___eUdDcT",
  "p0": "FeedVideo.module__duration___eUdDcT",
  "OC": "FeedVideo.module__player___eUdDcT",
  "h5": "FeedVideo.module__status___eUdDcT",
  "hw": "FeedVideo.module__reel___eUdDcT",
  "NF": "FeedVideo.module__controlsRoot___eUdDcT",
  "$_": "FeedVideo.module__media___eUdDcT",
  "u1": "FeedVideo.module__spinner___eUdDcT",
  "LY": "FeedVideo.module__unmute___eUdDcT",
  "O5": "FeedVideo.module__unmuteIcon___eUdDcT",
  "ne": "FeedVideo.module__controls___eUdDcT",
  "tl": "FeedVideo.module__controlsHidden___eUdDcT",
  "qB": "FeedVideo.module__progress___eUdDcT",
};

module.exports = exports;
